import { CODE_REGEX, UUID_REGEX } from '../constants'

export const isValidSetPasswordUrl = (code: string, code_uuid: string) => {
    if (typeof code !== 'string' || typeof code_uuid !== 'string') {
        return false
    }

    if (!CODE_REGEX.test(code)) {
        return false
    }

    if (!UUID_REGEX.test(code_uuid)) {
        return false
    }

    return true
}
